import { idSchema } from '@/lib/utils'
import { z } from 'zod/v4'

export const addOnSetParamsSchema = z.object({
  addOnSetId: idSchema('add-on set'),
})

const addOnSetItemSchema = z.object({
  id: idSchema('add-on'),
})

export const addOnSetSchema = z.object({
  name: z.string().trim().min(1, 'Name is required'),
  description: z.string().optional().nullable(),
  add_ons: z.array(addOnSetItemSchema).default([]),
  applies_to_collections: z.array(z.object({ id: idSchema('collection') })).default([]),
})
